export enum ProfileBookingRequestStatusEnum {
    OPEN = 'open',
    APPROVED = 'approved',
    WAITING_LIST = 'waiting_list',
    REJECTED = 'rejected',
    EXPIRED = 'expired',
    CANCELED = 'canceled',
    CANCELED_BY_LEARNER = 'canceled_by_learner',
    CANCELED_BY_TRAINING_RESPONSIBLE = 'canceled_by_training_responsible',
    CANCELED_BY_TRANSFER = 'canceled_by_transfer',
    TRANSFERRED = 'transferred',
}
